import {ResourceTaskTime} from "./ResourceTaskTime";
import {Resource} from "./Resource";
import {Task} from "app/entities/Task";
import {TaskPageModel} from './PageModel';

export class GantChart {
  PlacedTasks : ResourceTaskTime[];
  JobTasks : Resource[];
  ExternalTasks : Task[];
  ExternalPaginatedTasks : TaskPageModel = new TaskPageModel();

  // Maintenance
  FromDate  : string;
  ToDate    : string;
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/entities/GantChart.ts